import { useEffect, useReducer } from 'react'
import api, { ISettingsUser, ISettings } from '@api'
import { set } from 'lodash'
import { Toaster } from '@ui'
import { ApolloError } from 'apollo-boost'

enum Actions {
  SET_DATA,
  SET_PATH,
}

interface IState extends ISettings {
  user: ISettingsUser | null
  otpSecretKey: string
  otpPassword: string
  showOtpSecretKey: boolean
  otp: string
  tab: string | number
  showPasswordForm: boolean
}
export interface IUseSettings extends IState {
  setData: (data: any) => void
  setPath: (path: string, val: any) => void
  updateCompanySetting: (updatedSettings: Partial<{ [key in keyof ISettings]: any }>) => void
}

function reducer(state: IState, action: any) {
  switch (action.type) {
    case Actions.SET_DATA:
      return {
        ...state,
        ...action.data,
      }
    case Actions.SET_PATH:
      const _state = { ...state }
      set(_state, action.path, action.value)
      return _state
    default:
      return state
  }
}

export default function useSettings(init: any = {}): IUseSettings {
  const [data, dispatch] = useReducer(reducer, {
    user: null,
    oldPassword: '',
    otpSecretKey: '',
    showOtpSecretKey: false,
    otpPassword: '',
    otp: '',
    tab: 'profile',
    showPasswordForm: false,
    ...init,
  })

  useEffect(() => {
    api.company.settings
      .fetch()
      .then((settings) => dispatch({ type: Actions.SET_DATA, data: settings }))
  }, [])

  return {
    ...data,
    setData: (data: any) => dispatch({ type: Actions.SET_DATA, data }),
    setPath: (path: string, value: any) => dispatch({ type: Actions.SET_PATH, path, value }),
    updateCompanySetting: (updatedSettings) => {
      dispatch({
        type: Actions.SET_DATA,
        data: updatedSettings,
      })
      return api.company.settings
        .update(updatedSettings)
        .then((settings) => {
          dispatch({
            type: Actions.SET_PATH,
            path: 'user.company.settings',
            value: settings,
          })
          Toaster.success({ message: 'Saved' })
        })
        .catch((error: ApolloError) => Toaster.fail({ error }))
    },
  }
}
